import React, { useState, useEffect, useContext, useCallback } from "react";
import ListOrcamento from "../Lists/ListOrcamento/ListOrcamento";
import moment from "moment/moment";
import { AuthContext } from "../../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";

import "./OrcamentosComponent.scss";
import ModalAprovarOrcamento from "./components/ModalAprovarOrcamento";

import toast from "react-hot-toast";
import { useLoading } from "../../../../../shared/context/LoadingContext";

import ModalVerAvaliacao from "../AvaliacoesComponent/components/ModalVerAvaliacao";
import ModalVerOrcamento from "./components/ModalVerOrcamento/ModalVerOrcamento";

import ModalEditarDadosCredencial from "./components/ModalEditarDadosCredencial/ModalEditarDadosCredencial";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Alert,
} from "@mui/material";

function OrcamentosComponent({
  clienteId,
  sendRequest,
  token,
  dadosOrcamento,
}) {
  const { startLoading, stopLoading } = useLoading();
  const [orcamentos, setOrcamentos] = useState([]);
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [contaCorrente, setContaCorrente] = useState([]);

  // Hook para gerenciar o dialog
  const useConfirmDialog = () => {
    const [dialogProps, setDialogProps] = useState({
      open: false,
      title: "",
      message: "",
      details: null,
      agendamentos: [],
      confirmText: "",
      cancelText: "",
      onConfirm: () => {},
      onClose: () => {},
    });

    const showConfirmDialog = useCallback((props) => {
      return new Promise((resolve) => {
        setDialogProps({
          ...props,
          open: true,
          onConfirm: () => {
            setDialogProps((prev) => ({ ...prev, open: false }));
            resolve(true);
          },
          onClose: () => {
            setDialogProps((prev) => ({ ...prev, open: false }));
            resolve(false);
          },
        });
      });
    }, []);

    return {
      dialogProps,
      showConfirmDialog,
    };
  };

  const { dialogProps, showConfirmDialog } = useConfirmDialog();

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  //Modal Code
  const [modalDadosCredencial, setModalDadosCredencial] = useState({
    open: false,
    tipo: "",
  });

  // Estados para gerenciar os modais
  const [modalAvaliacao, setModalAvaliacao] = useState({
    open: false,
    data: null,
  });

  const [modalOrcamento, setModalOrcamento] = useState({
    open: false,
    data: null,
  });

  const [modalAprovarOrcamento, setModalAprovarOrcamento] = useState({
    open: false,
    data: null,
    conta: null,
  });

  const toggleEntregaClinica = useCallback(
    async (id) => {
      startLoading();
      try {
        const formData = new FormData();
        formData.append("utilizador", auth.userId);

        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/toggleEntregaClinica/${id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + token },
        );

        if (response.success) {
          setOrcamentos((prev) =>
            prev.map((orc) =>
              orc.id === id
                ? {
                    ...orc,
                    entregueNaClinica: response.orcamento.entregueNaClinica,
                  }
                : orc,
            ),
          );
          toast.success(response.mensagem);
        }
      } catch (err) {
        toast.error("Erro ao alterar entrega do orçamento");
      } finally {
        stopLoading();
      }
    },
    [sendRequest, token, auth.userId],
  );

  const handleOpenModal = useCallback(
    (id, tipo) => {
      let dadosFiltrados;
      const orcamentoFiltrado = orcamentos.filter((or) => or.id === id)[0];

      if (tipo === "orcamento") {
        dadosFiltrados = orcamentoFiltrado;
        setModalOrcamento({
          open: true,
          data: dadosFiltrados,
        });
      } else {
        dadosFiltrados = avaliacoes.filter(
          (av) => av.id === orcamentoFiltrado.avaliacao._id,
        )[0];
        setModalAvaliacao({
          open: true,
          data: dadosFiltrados,
        });
      }
    },
    [avaliacoes, orcamentos],
  );

  const handleCloseModalAvaliacao = () => {
    setModalAvaliacao({
      open: false,
      data: null,
    });
  };

  const handleCloseModalOrcamento = () => {
    setModalOrcamento({
      open: false,
      data: null,
    });
  };

  const handleCloseModalAprovarOrcamento = useCallback(() => {
    setModalAprovarOrcamento({
      open: false,
      data: null,
      conta: null,
    });
  }, []);
  ///////////////////////////////////////
  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [orcamentosResponse, avaliacoesResponse, contaCorrenteResponse] =
          await Promise.all([
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/cliente/${clienteId}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token },
            ),
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/cliente/comtratamento/${clienteId}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token },
            ),
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/cliente/${clienteId}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token },
            ),
          ]);

        // Process orcamentos
        const orcamentos = processOrcamentos(orcamentosResponse.orcamentos);
        setOrcamentos(filterByUserRole(orcamentos, auth));

        // Process avaliacoes
        const avaliacoes = processAvaliacoes(avaliacoesResponse.avaliacoes);
        setAvaliacoes(filterByUserRole(avaliacoes, auth));

        // Set conta corrente
        setContaCorrente(contaCorrenteResponse.contaCorrente);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [sendRequest, clienteId, auth]);

  // Helper functions
  const processOrcamentos = (orcamentos) => {
    return orcamentos
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .map((orcamento) => ({
        ...orcamento,
        data_orcamento: moment(orcamento.created_at).format("DD-MM-YYYY"),
      }));
  };

  const processAvaliacoes = (avaliacoes) => {
    return avaliacoes
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      .map((avaliacao) => ({
        ...avaliacao,
        data_avaliacao: moment(avaliacao.created_at).format("DD-MM-YYYY"),
      }));
  };

  const filterByUserRole = (items, auth) => {
    switch (auth.role) {
      case "Secretária(o)":
        return items.filter((item) =>
          auth.usuariosAssociados.some(
            (medico) => medico.id === item.medico_responsavel.id,
          ),
        );
      case "Assistente":
        return items.filter((item) =>
          auth.usuariosAssociados.some(
            (medico) => medico.id === item.medico_responsavel.id,
          ),
        );
      default:
        return items;
    }
  };
  ///////////////////////////////////////////////////////////////////
  const handleDesativar = useCallback(
    async (id, confirmarOperacao = false) => {
      // CORREÇÃO: Garantir que confirmarOperacao é sempre um booleano
      // Se for um evento (objeto), converter para false
      const confirmado =
        typeof confirmarOperacao === "boolean" ? confirmarOperacao : false;

      startLoading();
      // Buscar o orçamento para saber o status atual
      const orcamentoAtual = orcamentos.find((or) => or.id === id);
      const operacao = orcamentoAtual?.ativo ? "desativar" : "reativar";
      try {
        // Fazer a chamada para o backend
        const formData = new FormData();
        formData.append("utilizador", auth.userId);

        // Adicionar o flag de confirmação apenas se for true
        if (confirmado === true) {
          formData.append("confirmarOperacao", "true");
        }

        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/toggleativo/${id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + token,
          },
        );

        // Se precisa confirmação (há agendamentos)
        if (response.necessitaConfirmacao) {
          stopLoading();

          // Mostrar modal/dialog de confirmação
          const confirmar = await showConfirmDialog({
            title: `Confirmar ${operacao} orçamento`,
            message: response.mensagem,
            details: null,
            agendamentos: response.agendamentosProvisarios?.agendamentos || [],
            confirmText: `Sim, eliminar ${response.agendamentosProvisarios.quantidade} agendamento(s) e ${operacao}`,
            cancelText: "Cancelar",
          });

          if (confirmar) {
            // Chamar novamente com confirmação = true
            return handleDesativar(id, true);
          }
          return;
        }

        // Sucesso - atualizar estado local
        if (response.success) {
          stopLoading();

          // Atualizar lista de orçamentos
          if (orcamentoAtual?.ativo) {
            // Se estava ativo e foi desativado, remover da lista
            setOrcamentos((currentOrcamento) => {
              return currentOrcamento.filter((el) => el.id !== id);
            });
          } else {
            // Se estava inativo e foi reativado, atualizar na lista
            setOrcamentos((currentOrcamento) => {
              return currentOrcamento.map((el) => {
                if (el.id === id) {
                  return response.orcamento;
                }
                return el;
              });
            });
          }

          // Mostrar mensagem de sucesso
          toast.success(
            response.mensagem || `Orçamento ${operacao}do com sucesso!`,
          );

          // Se deletou agendamentos, mostrar informação adicional
          if (response.agendamentosDeletados > 0) {
            toast.info(
              `${response.agendamentosDeletados} agendamento(s) eliminado(s) permanentemente`,
              { duration: 5000 },
            );
          }
        }
      } catch (err) {
        stopLoading();
        console.error("Erro ao alterar status do orçamento:", err);
        toast.error(
          `Erro ao ${operacao || "alterar status do"} orçamento: ${
            err.message || "Erro desconhecido"
          }`,
        );
      }
    },
    [orcamentos, sendRequest, token, auth.userId, showConfirmDialog],
  );

  // Componente de Dialog de Confirmação (exemplo com Material-UI ou similar)
  const ConfirmDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    details,
    agendamentos,
    confirmText,
    cancelText,
  }) => {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{ bgcolor: "#f5f5f5", borderBottom: "2px solid #ff9800" }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <DialogContentText sx={{ mb: 2, fontWeight: 500 }}>
            {message}
          </DialogContentText>

          {details && (
            <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
              <strong>⚠️ Atenção:</strong> {details}
              <br />
              <small>Esta ação não pode ser desfeita.</small>
            </Alert>
          )}

          {agendamentos && agendamentos.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="subtitle1"
                gutterBottom
                sx={{
                  color: "error.main",
                  fontWeight: "bold",
                  mb: 2,
                }}
              >
                Agendamentos que serão ELIMINADOS permanentemente:
              </Typography>

              <List
                dense
                sx={{
                  bgcolor: "background.paper",
                  border: "2px solid #ff5722",
                  borderRadius: 1,
                  p: 1,
                }}
              >
                {agendamentos.map((ag, index) => {
                  const dataInicio = moment(ag.data_inicio || ag.data);
                  const dataFim = ag.data_fim ? moment(ag.data_fim) : null;

                  return (
                    <ListItem
                      key={ag.id || index}
                      sx={{
                        borderBottom:
                          index < agendamentos.length - 1
                            ? "1px solid #e0e0e0"
                            : "none",
                        py: 1.5,
                      }}
                    >
                      <ListItemText
                        primary={
                          <Box>
                            <Typography
                              variant="body1"
                              component="span"
                              fontWeight="bold"
                            >
                              {ag.tratamento || "Tratamento não especificado"}
                            </Typography>
                            <Typography
                              variant="body2"
                              component="div"
                              sx={{ mt: 0.5 }}
                            >
                              📅 {dataInicio.format("DD/MM/YYYY")} - ⏰{" "}
                              {dataInicio.format("HH:mm")}
                              {dataFim && ` até ${dataFim.format("HH:mm")}`}
                            </Typography>
                          </Box>
                        }
                        secondary={
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                          >
                            👨‍⚕️ Dr(a). {ag.medico || "Médico não definido"}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
              </List>

              <Alert severity="error" sx={{ mt: 2 }}>
                <strong>Total: {agendamentos.length} agendamento(s)</strong>{" "}
                serão permanentemente eliminados do sistema.
              </Alert>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
            size="large"
          >
            {cancelText || "Cancelar"}
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="error"
            size="large"
            sx={{ ml: 2 }}
          >
            {confirmText || "Confirmar"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renovarOrcamento = useCallback(
    async (id) => {
      startLoading();
      try {
        const formData = new FormData();
        formData.append("utilizador", auth.userId);

        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/renovar/${id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + token,
          },
        );

        if (response.success) {
          setOrcamentos((currentOrcamentos) => {
            // Remove o antigo e adiciona o novo
            return currentOrcamentos
              .filter((orc) => orc.id !== id)
              .concat({
                ...response.orcamento,
                data_orcamento: moment(
                  response.orcamento.dataRenovacao ||
                    response.orcamento.created_at,
                ).format("DD-MM-YYYY"),
              });
          });

          toast.success(
            `${response.mensagem}! Novo orçamento: ${response.estatisticas.numeroNovo}`,
          );

          if (response.estatisticas.agendamentosAtualizados > 0) {
            toast.info(
              `${response.estatisticas.agendamentosAtualizados} agendamento(s) atualizado(s)`,
              { duration: 4000 },
            );
          }
        }
      } catch (err) {
        console.error("Erro ao renovar orçamento:", err);
        toast.error(err.message || "Erro ao renovar orçamento");
      } finally {
        stopLoading();
      }
    },
    [sendRequest, token, auth.userId],
  );

  const aprovarOrcamento = useCallback(
    async (id) => {
      startLoading();
      try {
        const filteredConta = contaCorrente.contas.find(
          (conta) => conta.orcamento === id,
        );

        if (!filteredConta) {
          toast.error(
            "Conta não encontrada. Contacte os desenvolvedores do aplicativo.",
          );
          return;
        }

        // Caso 1: orçamento isento de pagamento → aprovar diretamente sem modal
        if (filteredConta.total === 0) {
          await aprovarOrcamentoIsento(id, filteredConta);
          return;
        }

        // Caso 2: orçamento com pagamento → abrir modal para configurar parcelas
        const filteredOrcamento = orcamentos.find((orc) => orc._id === id);

        // Preparar parcelas com vencimentos para o modal
        const contaAtualizada = JSON.parse(JSON.stringify(filteredConta));
        contaAtualizada.parcelas = contaAtualizada.parcelas.map(
          (parcela, index) => ({
            ...parcela,
            dataLimitePagamento: moment().add(
              clinica.clinica.configuracoes.configuracoes.validadeParcela
                .validade *
                (index + 1),
              "days",
            ),
          }),
        );

        setModalAprovarOrcamento({
          open: true,
          orcamento: filteredOrcamento,
          conta: contaAtualizada,
        });
      } catch (err) {
        console.error("err", err);
        toast.error("Erro ao iniciar aprovação do orçamento");
      } finally {
        stopLoading();
      }
    },
    [
      clinica.clinica,
      contaCorrente,
      orcamentos,
      sendRequest,
      token,
      auth.userId,
    ],
  );

  const aprovarOrcamentoIsento = useCallback(
    async (orcamentoId, conta) => {
      // 1. Buscar caixa da clínica
      let caixaClinicaId;
      try {
        const responseCaixa = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + token },
        );

        const caixaClinica = responseCaixa.caixas.find(
          (cx) => cx.caixa.toLowerCase() === "clínica",
        );

        if (!caixaClinica) {
          toast.error("Caixa da clínica não encontrada");
          return;
        }
        caixaClinicaId = caixaClinica._id;
      } catch (err) {
        console.error("Erro ao buscar caixa:", err);
        toast.error("Erro ao buscar caixa da clínica");
        return;
      }

      // 2. Encontrar o orçamento completo
      const orcamento = orcamentos.find((orc) => orc._id === orcamentoId);
      if (!orcamento) {
        toast.error("Orçamento não encontrado");
        return;
      }

      // 3. Preparar payload — uma única parcela simbólica "paga"
      const parcelaIsencao = {
        dataLimitePagamento: new Date(),
        dataPagamento: new Date(),
        parcelaPaga: true,
        metodoPagamento: "Dinheiro",
        quantiaPaga: 0,
        quantiaPorPagar: 0,
        nrParcela: "1/1",
        observacao: "Parcela de isenção",
        caixa: caixaClinicaId,
      };

      // 4. Preparar procedimentos do plano de tratamento
      const procedimentosPlanoTratamento = orcamento.procedimentos.map(
        (pr) => ({
          tratamento: pr.tratamento._id || pr.tratamento.id,
          dente: pr.dente,
          faces: pr.faces,
          procedimento_completo: false,
        }),
      );

      // 5. Montar payload (mesmo formato que o modal usa)
      const requestData = {
        procedimentosPlanoTratamento,
        procedimentosOrcamento: orcamento.procedimentos.map((p) => ({
          ...p,
          tratamento: p.tratamento._id || p.tratamento.id,
        })),

        tipoCobertura: orcamento.tipoCobertura,
        instituicaoCobertura: orcamento.instituicaoCobertura?._id || null,
        modalidadePagamento: orcamento.modalidadePagamento || null,
        valorCobertura: orcamento.valorCobertura || 0,

        parcelas: [parcelaIsencao],
        total: 0,
        subtotal: orcamento.subtotal,
        subtotalCliente: orcamento.subtotalCliente,
        desconto: orcamento.desconto,
        tipoDesconto: orcamento.tipoDesconto,
        percentagemDescontoOriginal: orcamento.percentagemDescontoOriginal,

        observacoes: orcamento.observacoes,
        beneficio: orcamento.beneficio,
        majoracao: orcamento.majoracao || 0,
        comMajoracao: orcamento.comMajoracao || false,

        ...(orcamento.dataCredencial && {
          dataCredencial: orcamento.dataCredencial,
          nrCredencial: orcamento.nrCredencial,
        }),

        cliente: orcamento.cliente._id || orcamento.cliente.id,
        clinica: orcamento.clinica._id || orcamento.clinica.id,
        medicoResponsavel:
          orcamento.medico_responsavel._id || orcamento.medico_responsavel.id,
        utilizador: auth.userId,
        caixaClinicaId,
        contaCorrenteId: contaCorrente._id,
        contaId: conta._id || conta.id,

        aprovacaoParcial: false,
        confirmarConversaoAgendamentos: true, // isento — assumimos aprovação total
        categoriaBeneficiario: orcamento.categoriaBeneficiario || null,
      };

      // 6. Uma só chamada — atómica no backend
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/aprovar/${orcamentoId}`,
          "POST",
          JSON.stringify(requestData),
          {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        );

        if (response.success && response.orcamento) {
          toast.success("Orçamento isento de pagamento aprovado com sucesso!");

          // Atualizar estado local
          setOrcamentos((prev) =>
            prev.map((or) =>
              or._id === orcamentoId ? response.orcamento : or,
            ),
          );
        }
      } catch (err) {
        console.error("Erro ao aprovar orçamento isento:", err);
        toast.error(err.message || "Erro ao aprovar orçamento isento");
      }
    },
    [
      orcamentos,
      contaCorrente,
      clinica.clinica._id,
      sendRequest,
      token,
      auth.userId,
    ],
  );

  const orcamentoData = (
    tipo,
    instituicao,
    serviceList,
    cliente,
    clinica,
    medico_responsavel,
    numero,
    desconto,
    tipoDesconto,
    orcamentoMisto,
    created_at,
    transformado,
    dataAprovacao,
    modalidadePagamento,
    subtotal,
  ) => {
    const dados = {
      tipo,
      instituicao,
      serviceList,
      cliente,
      clinica,
      medico_responsavel,
      numero,
      desconto,
      tipoDesconto,
      orcamentoMisto,
      created_at,
      transformado,
      dataAprovacao,
      modalidadePagamento,
      subtotal,
    };
    dadosOrcamento(dados);
  };

  const preAdicionarCredencialHandler = (id) => {
    const filteredOrcamento = orcamentos.find((o) => o._id === id);
    setModalDadosCredencial({
      open: true,
      tipo: "inserir",
      idOrcamento: id,
      beneficio: filteredOrcamento.beneficio,
    });
  };

  const preEditarDadosCredencialHandler = (id) => {
    const filteredOrcamento = orcamentos.find((o) => o._id === id);
    setModalDadosCredencial({
      open: true,
      tipo: "editar",
      idOrcamento: id,
      nrCredencial: filteredOrcamento.nrCredencial,
      dataCredencial: filteredOrcamento.dataCredencial,
      categoriaBeneficiario: filteredOrcamento.categoriaBeneficiario,
      beneficio: filteredOrcamento.beneficio,
    });
  };

  const handleCloseModalDadosCredencial = () => {
    setModalDadosCredencial({ open: false, tipo: "" });
  };

  const handleUpdateCredencialData = (
    nrCredencial,
    dataCredencial,
    idOrc,
    categoria,
  ) => {
    const updatedOrcamentos = orcamentos.map((orc) => {
      if (orc._id === idOrc) {
        return {
          ...orc,
          nrCredencial,
          dataCredencial,
          ...(categoria && { categoriaBeneficiario: categoria }),
        };
      }
      return orc;
    });
    setOrcamentos(updatedOrcamentos);
  };

  const updateOrcamentos = (orcamentoAtualizar) => {
    setOrcamentos((prev) =>
      prev.map((or) =>
        or._id === orcamentoAtualizar._id
          ? {
              ...orcamentoAtualizar,
              data_orcamento: moment(orcamentoAtualizar.created_at).format(
                "DD-MM-YYYY",
              ),
            }
          : or,
      ),
    );
  };

  return (
    <>
      {/* Modal de Avaliação */}
      <ModalVerAvaliacao
        open={modalAvaliacao.open}
        handleClose={handleCloseModalAvaliacao}
        data={modalAvaliacao.data}
      />

      {/* Modal de Orçamento */}
      <ModalVerOrcamento
        open={modalOrcamento.open}
        handleClose={handleCloseModalOrcamento}
        data={modalOrcamento.data}
      />

      {/* Modal Aprovar Orcamento */}
      {modalAprovarOrcamento.open && (
        <ModalAprovarOrcamento
          open={modalAprovarOrcamento.open}
          modalData={modalAprovarOrcamento}
          handleCloseModalAprovarOrcamento={handleCloseModalAprovarOrcamento}
          sendRequest={sendRequest}
          auth={auth}
          contaCorrente={contaCorrente}
          updateOrcamentos={updateOrcamentos}
          clinica={clinica}
        />
      )}

      {(modalDadosCredencial.tipo === "inserir" ||
        modalDadosCredencial.tipo === "editar") && (
        <ModalEditarDadosCredencial
          open={modalDadosCredencial.open}
          handleCloseModal={handleCloseModalDadosCredencial}
          idOrcamento={modalDadosCredencial.idOrcamento}
          dataInicial={modalDadosCredencial.dataCredencial}
          nrCredencialInicial={modalDadosCredencial.nrCredencial}
          categoriaInicial={modalDadosCredencial.categoriaBeneficiario}
          beneficio={modalDadosCredencial.beneficio}
          sendRequest={sendRequest}
          token={token}
          handleUpdateCredencialData={handleUpdateCredencialData}
        />
      )}

      {orcamentos.length !== 0 ? (
        <ListOrcamento
          orcamentoData={orcamentoData}
          data={orcamentos}
          handleOpenModal={handleOpenModal}
          aprovarOrcamento={aprovarOrcamento}
          handleDesativar={handleDesativar}
          renovarOrcamento={renovarOrcamento}
          preAdicionarCredencialHandler={preAdicionarCredencialHandler}
          preEditarDadosCredencialHandler={preEditarDadosCredencialHandler}
          auth={auth}
          clinica={clinica.clinica}
          toggleEntregaClinica={toggleEntregaClinica}
        />
      ) : (
        <div className="no_data_div">Nenhum Orçamento encontrado.</div>
      )}

      <ConfirmDialog {...dialogProps} />
    </>
  );
}

export default OrcamentosComponent;
